import _ from 'lodash'
import { diff } from '../lib/render-object'


const mapper = (text) => {
  return {
    'isdefault': 'Default Chart',
  }[text] || _.startCase(text)
}

const alwaysDrop = [
  "_cashflowmapcount",
  "externalreference",
  "_detailaccountcount",
  "_summaryaccountcount",
  "organizationid",
  "notedetail",
  "status"
]
export const diffif = (props) => {
  if (props.resource !== 'chart') return null

  return () => {
    let change = JSON.parse(props.change)
    const diffs = diff(change.old, change.new, mapper, null, alwaysDrop)

    const atRest =
      props.method == 'POST' ? 'Created Chart' : 
      props.method == 'DELETE' ? 'Deleted Chart' : 'Chart Change'

    return {diffs, atRest, ...props}
  }
}